import { createSlice } from "@reduxjs/toolkit";
import {
  CheckValue,
  checkRole,
  rankIndex,
} from "../services/CommonFunction";
import { staticVar } from "../services/Constants";
import { setStaff } from "../services/SetApiResponse";
import { userData } from "../services/subscriberService";
import { StaffSort } from "../containers/ActivityList/ActivityService";
import { selectIcon } from "../components/UI/selector";

const initialState = {
  storage: {
    firstTime: true,
    isBoardView: false,
    cameraId: null,
    audioId: null,
    isCameraEnabled: false,
    isAudioEnabled: false,
    isStreamingThruObs: false,
    UseOrConfig: false,
    UseHrConfig: false,
  },
  pagination: {
    currentPage: 1,
    hangoutPageSize: 12,
    videoPageSize: 12,
    boardPageSize: 20,
    paginationStatus: false,
  },
  data: {
    coachData: {},
    constraints: {
      audio: { autoplay: true, deviceId: "" },
      video: { width: 1280, height: 720, deviceId: "" },
    },
    count: {
      value: -1,
      max: 0,
      showCircelProgressBar: false,
    },
    totalSeconds: 0,
    role_type: 1,
    usersInActivity: [],
    class_summary: {},
    userId: {},
    staffsInActivity: {},
    activityLogo: {
      name: "",
      id: "",
      keyValue: "id",
      thumb: selectIcon("activityImage"),
      original: selectIcon("activityImage"),
    },
    cameraList: [],
    audioList: [],
    speakerList: [],
    showUser: [],
    videoStatus: [],
    isVideoPlaying: false,
    canvasUpdate: false,
    isCoachStream: false,
    isOwnerStream: false,
    avSetupStatus: false,
    muteAll: true,
    room_id: undefined,
    activeSpeakerStatus: [],
    passInfo: undefined,
    sessionStatus: -1,
    activeSpeaker: undefined,
    activeStreamExercise: undefined,
    token: undefined,
    started_at: "",
    ended_at: "",
    started_time: undefined,
    created_by: "",
    waitingRoom_open_by: "",
    activity_name: "",
    deviceId: "",
    started: false,
    ivsJoin: false,
    startBroadcast: false,
    isHost: false,
    isSocket: false,
    started_by: true,
    low_latency_mode: null,
    liveLatency: 0,
    streaming_started_by: true,
    streaming_ended_by: true,
    streamUrl: undefined,
    stream_key: undefined,
    activity_id: undefined,
    activity_status: staticVar.waitingRoom,
    deviceUpdate: [],
    myStatus: false,
    isHeartRate: false,
    isLeaderBoard: false,
    host: false,
    mainHost: false,
    allUsers: {},
    average: {
      min_calories_burnt: "",
      max_calories_burnt: "",
      avg_calories_burnt: "",
      min_of_max_heart_rate_percent: "",
      max_of_max_heart_rate_percent: "",
      avg_of_max_heart_rate_percent: "",
    },
    workout_builder: [],
    ivsStatus: false,
    playback_url: undefined,
    status: undefined,
  },
  chat: {
    messageList: {},
    highLightMessageData: [],
    highLightmessage: false,
  },
  status: staticVar.idle,
};

const checkRoleAccess = (value) => {
  if (checkRole("gym")) {
    return true;
  } else {
    if (value === undefined || value === "" || value === null) {
      return true;
    }
    if (value === userData.detail.user_id) {
      return true;
    }
    return false;
  }
};

const isJson = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return {
      user_id: str,
      timestamp: +new Date(),
    };
  }
  return JSON.parse(str);
};

const checkCond = (data) => {
  return data === "COACH_ONLY" || data === "ALL";
};

export const getUserArray = (data, activity_status) => {
  let userArr = data.sort(rankIndex);
  if (activity_status === staticVar.waitingRoom) {
    userArr = userArr.filter(
      (el) => el.user_status_in_activity !== staticVar.ended
    );
  } else if (activity_status === staticVar.hangout) {
    userArr = userArr.filter(
      (el) =>
        el.user_status_in_activity === staticVar.hangout ||
        el.user_status_in_activity === staticVar.roomStarted
    );
  }
  const userArrLength = userArr.length;
  return {
    userArr,
    userArrLength,
  };
};

const getShowUser = (allUsers, activity_status) => {
  let showUser = [];
  if (Object.values(allUsers).length) {
    const { userArr, userArrLength } = getUserArray(
      Object.values(allUsers),
      activity_status
    );
    if (userArrLength > 12) {
      showUser = userArr.slice(0, 12).map((el) => el.user_id);
    } else {
      showUser = userArr.slice(0, userArrLength).map((el) => el.user_id);
    }
  }
  return showUser;
};

const currentClassSlice = createSlice({
  name: "currentClass",
  initialState,
  reducers: {
    setClassData: {
      reducer(state, action) {
        let data = { ...state.data };

        state.status = staticVar.done;
        state.data = {
          ...data,
          showUser: getShowUser(
            action.payload.allUsers,
            action.payload.activity_status
          ),
          started_at: action.payload.started_at,
          started_by: checkRoleAccess(action.payload.started_by),
          streaming_started_by: checkRoleAccess(
            action.payload.streaming_ended_by
          ),
          streaming_ended_by: checkRoleAccess(
            action.payload.streaming_started_by
          ),
          streamUrl: action.payload.streamUrl,
          activityLogo: action.payload.activityLogo,
          stream_key: action.payload.stream_key,
          activity_status: action.payload.activity_status,
          myStatus: action.payload.myStatus,
          isHeartRate: action.payload.heartrate_required,
          isLeaderBoard: action.payload.leaderboard_type,
          allUsers: { ...action.payload.allUsers },
          average: { ...action.payload.average },
          workout_builder: [...action.payload.workout_builder],
          ivsStatus: action.payload.streaming,
          playback_url: action.payload.playback_url,
          isHost: action.payload.mainHost && action.payload.host,
          mainHost: action.payload.mainHost,
          host: action.payload.host,
          isSocket: true,

          activity_name: action.payload.activity_name,
          staffsInActivity: action.payload.staffsInActivity,
          coachData: action.payload.coachData,
          activity_id: action.payload.activity_id,
          created_by: action.payload.created_by,
          waitingRoom_open_by: action.payload.waitingRoom_open_by,
          started_time: action.payload.start_datetime,
          room_id: action.payload.room_id,
          ended_at: action.payload.ended_at,
          low_latency_mode: action.payload.low_latency_mode,
          duration_in_second: action.payload.duration_in_second,
        };
        if (
          !action.payload.low_latency_mode &&
          action.payload.activity_status === staticVar.roomStarted
        ) {
          state.data.sessionStatus = action.payload.streaming ? 1 : 0;
        }
        if (action.payload.activity_status === staticVar.waitingRoom) {
          state.data.totalSeconds = action.payload.previousSeconds;
        } else {
          state.data.totalSeconds = action.payload.totalSeconds;
        }
        if (action.payload.activity_status === staticVar.roomStarted) {
          state.chat.highLightmessage = true;
        } else {
          state.chat.highLightmessage = false;
        }
      },
      prepare(data) {
        return {
          payload: { ...JSON.parse(JSON.stringify(data)) },
        };
      },
    },
    updateClassData: {
      reducer(state, action) {
        let data = { ...state.data };

        state.data = {
          ...data,
          started_at: action.payload.started_at,
          started_by: checkRoleAccess(action.payload.started_by),
          streaming_started_by: checkRoleAccess(
            action.payload.streaming_ended_by
          ),
          streaming_ended_by: checkRoleAccess(
            action.payload.streaming_started_by
          ),
          streamUrl: action.payload.streamUrl,
          stream_key: action.payload.stream_key,
          activity_status: action.payload.activity_status,
          myStatus: action.payload.myStatus,
          average: { ...action.payload.average },
          ivsStatus: action.payload.streaming,
          playback_url: action.payload.playback_url,
          ended_at: action.payload.ended_at,
        };
        if (action.payload.activity_status === staticVar.waitingRoom) {
          state.data.totalSeconds = action.payload.previousSeconds;
        } else {
          state.data.totalSeconds = action.payload.totalSeconds;
        }

        if (
          !action.payload.low_latency_mode &&
          action.payload.activity_status === staticVar.roomStarted
        ) {
          state.data.sessionStatus = action.payload.streaming ? 1 : 0;
        } else if (
          !action.payload.low_latency_mode &&
          action.payload.activity_status === staticVar.hangout
        ) {
          state.data.sessionStatus = -1;
        }
        if (action.payload.activity_status === staticVar.roomStarted) {
          state.chat.highLightmessage = true;
        } else {
          state.chat.highLightmessage = false;
        }
      },
      prepare(data) {
        return {
          payload: { ...JSON.parse(JSON.stringify(data)) },
        };
      },
    },
    setPassInfo: (state, action) => {
      state.data.passInfo = action.payload;
    },
    avSetupToggle: (state, action) => {
      state.data.avSetupStatus = action.payload;
    },
    deviceUpdated: (state, action) => {
      state.data.deviceUpdate = [...state.data.deviceUpdate, action.payload];
    },
    addActivityId: (state, action) => {
      state.data.role_type = action.payload.role_type;
      state.data.deviceId = localStorage.getItem("setId");
      state.data.activity_id = action.payload.activity_id;
    },
    setToken: (state, action) => {
      state.data.token = action.payload;
    },
    setSession: (state, action) => {
      state.data.sessionStatus = action.payload;
    },
    streamStart: (state, action) => {
      let data = { ...state.data };
      state.data = {
        ...data,
        ivsStatus: true,
        streamUrl: action.payload.inputRTMPURL,
        stream_key: action.payload.streamKey,
        streaming_started_by: checkRoleAccess(
          action.payload.streaming_started_by
        ),
        playback_url: action.payload.playbackUrl,
      };
      if (state.data.activity_status === staticVar.roomStarted) {
        state.data.sessionStatus = 1;
      }
    },
    streamEnd: (state, action) => {
      let data = { ...state.data };
      state.data = {
        ...data,
        ivsStatus: false,
        streamUrl: undefined,
        stream_key: undefined,
        streaming_ended_by: checkRoleAccess(action.payload.streaming_ended_by),
      };
      if (state.data.activity_status === staticVar.roomStarted) {
        state.data.sessionStatus = 0;
      }
    },
    setClassAverage: (state, action) => {
      const data = JSON.parse(JSON.stringify(state.data));
      const { isHeartRate, activity_status, average } = data;
      if (isHeartRate) {
        [
          "min_of_max_heart_rate_percent",
          "max_of_max_heart_rate_percent",
          "avg_of_max_heart_rate_percent",
        ].forEach((el) => {
          average[el] = CheckValue(action.payload[el])
            ? Math.round(action.payload[el])
            : "";
        });
        if (activity_status !== staticVar.waitingRoom) {
          [
            "min_calories_burnt",
            "max_calories_burnt",
            "avg_calories_burnt",
          ].forEach((el) => {
            average[el] = CheckValue(action.payload[el])
              ? Math.round(action.payload[el])
              : "- - -";
          });
        }
        state.data = {
          ...data,
          average: {
            ...data.average,
            average,
          },
        };
      }
    },
    addUser: (state, action) => {
      const data = JSON.parse(JSON.stringify(state.data));
      const allUsers = { ...data.allUsers };
      // ========== ALREADY EXISTED USER IN ONGOING ACTIVITY==============
      let oldData = {};
      if (allUsers.hasOwnProperty(action.payload.user_id)) {
        oldData = {
          ...allUsers[action.payload.user_id],
          first_name: action.payload.first_name,
          last_name: action.payload.last_name,
          name: action.payload.first_name + " " + action.payload.last_name,
        };
      } else {
        oldData = {
          ...action.payload,
          name: action.payload.first_name + " " + action.payload.last_name,
        };
      }

      allUsers[action.payload.user_id] = {
        ...oldData,
        isRemoved: false,
        user_status_in_activity: staticVar.roomStarted,
      };
      data.showUser = getShowUser(allUsers, data.activity_status);
      state.data = {
        ...data,
        allUsers: {
          ...allUsers,
        },
      };
    },
    userAddZoom: (state, action) => {
      const data = JSON.parse(JSON.stringify(state.data));
      if (Object.keys(action.payload.coach).length) {
        Object.keys(action.payload.coach).forEach((el) => {
          data.coachData[el] = action.payload.coach[el];
        });
      }
      if (Object.keys(action.payload.userId).length) {
        Object.keys(action.payload.userId).forEach((el) => {
          data.userId[el] = action.payload.userId[el];
        });
      }
      state.data = { ...data };
    },
    userRemoveZoom: (state, action) => {
      const data = JSON.parse(JSON.stringify(state.data));
      if (CheckValue(action.payload.coach)) {
        delete data.coachData[action.payload.coach];
      }
      if (CheckValue(action.payload.userId)) {
        delete data.userId[action.payload.userId];
      }
      state.data = { ...data };
    },
    updateUserHeartRate: (state, action) => {
      const { user_id, max_heart_rate_percent, calories_burnt } =
        action.payload;
      if (user_id && CheckValue(state.data.allUsers[user_id])) {
        state.data.allUsers[user_id].max_heart_rate_percent = Math.round(
          max_heart_rate_percent || 0
        );
        if (
          state.data.activity_status === staticVar.roomStarted &&
          state.data.allUsers[user_id]["user_status_in_activity"] ===
            staticVar.roomStarted &&
          CheckValue(calories_burnt)
        ) {
          state.data.allUsers[user_id].calories_burnt = Math.round(
            calories_burnt || 0
          );
        }
      }
    },
    removeUser: (state, action) => {
      const data = JSON.parse(JSON.stringify(state.data));
      const allUsers = { ...data.allUsers };
      if (allUsers.hasOwnProperty(action.payload.user_id)) {
        allUsers[action.payload.user_id]["isRemoved"] = true;
        allUsers[action.payload.user_id]["user_status_in_activity"] =
          staticVar.ended;
        data.showUser = getShowUser(allUsers, data.activity_status);
        state.data = {
          ...data,
          allUsers: {
            ...allUsers,
          },
        };
      }
    },
    staffJoined: (state, action) => {
      const data = JSON.parse(JSON.stringify(state.data));
      const { deviceId, staffsInActivity, created_by, waitingRoom_open_by } =
        data;
      const { infoOfJoinedStaff } = action.payload;
      if (infoOfJoinedStaff.user_id === userData.detail.user_id) {
        if (
          infoOfJoinedStaff.device_type === staticVar.web &&
          infoOfJoinedStaff.device_id !== deviceId
        ) {
          state.data.status = "joinedAnotherDevice";
          return;
        }
      }
      const role =
        typeof infoOfJoinedStaff.roles === "string"
          ? [infoOfJoinedStaff.roles]
          : infoOfJoinedStaff.roles;
      if (
        userData.detail.user_id === infoOfJoinedStaff.user_id ||
        (infoOfJoinedStaff.user_id !== created_by &&
          infoOfJoinedStaff.user_id !== waitingRoom_open_by)
      ) {
        return;
      }
      let socket_id = [];
      if (!CheckValue(data.socket_id)) {
        return;
      }
      if (CheckValue(staffsInActivity[infoOfJoinedStaff.user_id])) {
        socket_id = [
          ...staffsInActivity[infoOfJoinedStaff.user_id].socket_id,
          data.socket_id,
        ];
        socket_id = StaffSort(socket_id);
      } else {
        socket_id.push(data.socket_id);
      }
      state.data = {
        ...data,
        staffsInActivity: {
          ...data.staffsInActivity,
          [infoOfJoinedStaff.user_id]: setStaff(
            { ...infoOfJoinedStaff, socket_id: data.socket_id },
            role
          ),
        },
      };
    },
    staffLeft: (state, action) => {
      const data = JSON.parse(JSON.stringify(state.data));
      const {
        staffsInActivity,
        mainHost,
        created_by,
        waitingRoom_open_by,
        host,
      } = data;
      const { infoOfLeftStaff } = action.payload;
      const staffData = staffsInActivity[infoOfLeftStaff.user_id];
      if (CheckValue(infoOfLeftStaff) && staffData) {
        staffData.socket_id = staffData.socket_id.filter(
          (el) => el !== infoOfLeftStaff.socket_id
        );
        if (!staffData.socket_id.length) {
          if (
            !mainHost &&
            infoOfLeftStaff.user_id === created_by &&
            userData.detail.user_id === waitingRoom_open_by
          ) {
            data.mainHost = true;
            data.coachData.host = false;
            data.coachData.ownerHost = true;
            data.status = "makeHost";
          } else if (
            mainHost &&
            infoOfLeftStaff.user_id === userData.detail.user_id &&
            userData.detail.user_id === waitingRoom_open_by
          ) {
            if (!host) {
              data.status = "askStreaming";
            }
          }
          delete staffsInActivity[infoOfLeftStaff.user_id];
        }
      }
      state.data = { ...data };
    },
    setCoachRemove: (state, action) => {
      const coachData = { ...state.data.coachData };
      const allUsers = { ...state.data.allUsers };
      const userId = { ...state.data.userId };
      const id = userId[action.payload];
      if (allUsers.hasOwnProperty(id)) {
        if (allUsers[id].userId === id) {
          if (allUsers[id].isVideoStarted) {
            state.data.videoStatus = [
              ...state.data.videoStatus,
              { status: "stopVideo", user_id: id },
            ];
          }
          delete allUsers[id].userId;
          state.data.allUsers = allUsers;
        }
      } else if (
        coachData.userId === action.payload ||
        coachData.ownerUserId === action.payload
      ) {
        if (coachData.userId === action.payload) {
          if (coachData.MOBILE === action.payload) {
            delete coachData["MOBILE"];
          } else if (coachData.WEB === action.payload) {
            delete coachData["WEB"];
          }
        } else if (coachData.ownerUserId === action.payload) {
          if (coachData.ownerMOBILE === action.payload) {
            delete coachData["ownerMOBILE"];
          } else if (coachData.ownerWEB === action.payload) {
            delete coachData["ownerWEB"];
          }
        }
        state.data.coachData = coachData;
      }
      state.data.allUsers = allUsers;
      deleteUserId([action.payload]);
    },
    hostUpdate: (state, action) => {
      if (action.payload) {
        localStorage.setItem("host", true);
      } else {
        localStorage.removeItem("host");
      }
      state.data.host = action.payload;
      state.data.isHost = action.payload && state.data.mainHost;
    },
    mainHostUpdate: (state, action) => {
      state.data.mainHost = action.payload;
      state.data.isHost = state.data.host && action.payload;
    },
    stopAttendeeVideos: (state, action) => {
      const userId = { ...state.data.userId };
      if (CheckValue(userId[action.payload])) {
        if (
          state.data.allUsers.hasOwnProperty(userId[action.payload]) &&
          state.data.allUsers[userId[action.payload]].isVideoStarted
        ) {
          state.data.allUsers[userId[action.payload]].isVideoStarted = false;
        } else if (
          !state.data.allUsers.hasOwnProperty(userId[action.payload])
        ) {
          delete userId[action.payload];
          state.data.userId = userId;
        }
      }
    },
    startAttendeeVideos: (state, action) => {
      const userId = { ...state.data.userId };
      if (CheckValue(userId[action.payload])) {
        if (
          state.data.allUsers.hasOwnProperty(userId[action.payload]) &&
          !state.data.allUsers[userId[action.payload]].isVideoStarted
        ) {
          state.data.allUsers[userId[action.payload]].isVideoStarted = true;
        }
      }
    },
    antMediaStatus: (state, action) => {
      state.data.allUsers[action.payload.user_id].isVideoStarted =
        action.payload.isVideoStarted;
    },
    updateMemberStream: (state, action) => {
      if (state.data.allUsers.hasOwnProperty(action.payload.user_id)) {
        if (action.payload.value) {
          state.data.allUsers[
            action.payload.user_id
          ].participant_video_visibility =
            action.payload.participant_video_visibility_in_attempt;
          if (
            checkCond(action.payload.participant_video_visibility_in_attempt)
          ) {
            state.data.allUsers[
              action.payload.user_id
            ].user_activity_session_id =
              action.payload.user_activity_session_id;
            state.data.allUsers[action.payload.user_id].stream = true;
          }
        } else {
          state.data.allUsers[action.payload.user_id].stream = false;
        }
      }
    },
    coachDataAdd: (state, action) => {
      const coachData = { ...state.data.coachData };
      const allUsers = { ...state.data.allUsers };
      const data = isJson(action.payload.displayName);
      const id = data.user_id.split("_");
      if (allUsers.hasOwnProperty(id[0])) {
        const user = allUsers[id[0]];
        if (CheckValue(user.timestamp)) {
          if (data.timestamp < user.timestamp) {
            return;
          }
        }
        user.timestamp = data.timestamp;
        user["muted"] = action.payload.muted;
        if (CheckValue(user.userId)) {
          if (user.isVideoStarted) {
            state.data.videoStatus = [
              ...state.data.videoStatus,
              { status: "stopVideo", user_id: user.userId },
            ];
          } else {
            deleteUserId([user.userId]);
          }
        }
        user.userId = action.payload.userId;
        user.isVideoStarted = false;
        if (
          state.data.activity_status !== staticVar.roomStarted ||
          checkCond(allUsers[id].participant_video_visibility)
        ) {
          user["stream"] = action.payload.bVideoOn;
        }
      } else if (
        coachData.waitingRoom_open_by === id[0] ||
        coachData.user_id === id[0]
      ) {
        let key = id[1];
        let status = "";
        if (coachData.waitingRoom_open_by === id[0]) {
          key += "_owner";
          status = "owner";
        }
        key += "_timestamp";
        if (CheckValue(coachData[key]) && data.timestamp < coachData[key]) {
          return;
        }
        coachData[key] = data.timestamp;
        coachData[status + id[1]] = action.payload.userId;
        if (coachData.user_id === id[0]) {
          coachData.ownerHost = false;
          if(coachData.ownerStream) {
            coachData.ownerStream = false;
          }
        }
        state.data = {
          ...state.data,
          coachData,
          allUsers,
        };
      }
      state.data.userId[action.payload.userId] = id[0];
    },
    setCoachData: (state, action) => {
      state.data.coachData = {
        ...state.data.coachData,
        ...action.payload,
      };
    },
    setUserMuted: (state, action) => {
      const id = state.data.userId[action.payload.userId];
      if (
        state.data.allUsers.hasOwnProperty(id) &&
        CheckValue(action.payload.muted)
      ) {
        state.data.allUsers[id].muted = action.payload.muted;
        if (
          CheckValue(state.data.activeSpeaker) &&
          action.payload.muted &&
          state.data.activeSpeaker.user_id === id
        ) {
          state.data.activeSpeaker = undefined;
        }
      }
    },
    setTotalSeconds: (state, action) => {
      state.data.totalSeconds = action.payload;
    },
    addUserId: (state, action) => {
      Object.keys(action.payload).forEach((el) => {
        state.data.userId[el] = action.payload[el];
      });
    },
    deleteUserId: (state, action) => {
      const userId = { ...state.data.userId };
      action.payload.forEach((el) => {
        if (userId.hasOwnProperty(el)) {
          delete userId[el];
        }
      });
      state.data.userId = userId;
    },
    setStream: (state, action) => {
      state.data.stream = action.payload;
    },
    zoomCoachVideoUpdate: (state, action) => {
      let coachData = JSON.parse(JSON.stringify(state.data.coachData));
      if (action.payload.delete.length) {
        action.payload.delete.forEach((el) => {
          delete coachData[el];
        });
      }
      if (action.payload.isCoach) {
        coachData = {
          ...coachData,
          ...action.payload.coach,
        };
      } else {
        coachData = {
          ...coachData,
          ...action.payload.owner,
        };
      }
      state.data.coachData = coachData;
    },
    updateData: (state, action) => {
      let data = JSON.parse(JSON.stringify(state.data));
      state.data = {
        ...data,
        ...action.payload,
      };
    },
    setCount: (state, action) => {
      state.data.count = action.payload;
    },
    videoStateChange: (state, action) => {
      const data = JSON.parse(JSON.stringify(state.data));
      const { userId, coachData, allUsers, activity_status } = data;
      if (userId.hasOwnProperty(action.payload.userId)) {
        const id = userId[action.payload.userId];
        if (allUsers.hasOwnProperty(id)) {
          if (
            activity_status === staticVar.roomStarted &&
            !checkCond(allUsers[id].participant_video_visibility)
          ) {
            return;
          }
          state.data.allUsers[id]["stream"] = action.payload.action === "Start";
        } else if (coachData.user_id === id) {
          if (
            !CheckValue(coachData.deviceType) ||
            coachData.deviceType === action.payload.userId
          ) {
            if (action.payload.action === "Start") {
              state.data.coachData.deviceType = action.payload.userId;
            }
            state.data.isCoachStream = action.payload.action === "Start";
          }
        } else if (coachData.waitingRoom_open_by === id) {
          if (
            !CheckValue(coachData.deviceType) ||
            coachData.deviceType === action.payload.userId
          ) {
            if (coachData.ownerHost) {
              if (action.payload.action === "Start") {
                state.data.coachData.deviceType = action.payload.userId;
              }
              state.data.isOwnerStream = action.payload.action === "Start";
            } else {
              state.data.coachData.ownerStream = false;
            }
          }
        }
      }
    },
    resetCount: (state) => {
      state.data.count = { ...initialState.data.count };
    },
    resetCurrentClass: (state) => {
      state.data = { ...initialState.data };
      state.status = initialState.status;
      state.storage = initialState.storage;
    },
    setClassStorage: (state, action) => {
      state.storage = {
        ...state.storage,
        ...action.payload,
      };
      localStorage.setItem(
        [`${state.data.activity_id}_class`],
        JSON.stringify(state.storage)
      );
    },
    toggleCanvasStatus: (state, action) => {
      state.data.canvasUpdate = action.payload;
    },
    setVideoStatus: (state, action) => {
      state.data.videoStatus = [...state.data.videoStatus, action.payload];
    },
    setActiveSpeaker: (state, action) => {
      state.data.activeSpeaker = action.payload;
    },
    setActiveSpeakerStatus: (state, action) => {
      state.data.activeSpeakerStatus = [
        ...state.data.activeSpeakerStatus,
        action.payload,
      ];
    },
    setMessageList: (state, action) => {
      const messageList = JSON.parse(JSON.stringify(state.chat.messageList));
      action.payload.forEach((el) => {
        messageList[el.message_id] = { ...el, deliverd: true };
      });
      state.chat.messageList = messageList;
    },
    addNewMessage: (state, action) => {
      const isHighLightmessage = state.chat.highLightmessage;
      const messageList = JSON.parse(JSON.stringify(state.chat.messageList));
      const coachData = JSON.parse(JSON.stringify(state.data.coachData));
      if (
        isHighLightmessage &&
        CheckValue(action.payload.receiver_id) &&
        !CheckValue(messageList[action.payload.message_id])
      ) {
        let show = false;
        const memberData = userData.detail;
        const sender = action.payload.sender_id === memberData.user_id;
        const receiver = action.payload.receiver_id === memberData.user_id;
        if (
          !sender &&
          ((coachData.host && receiver) ||
            (action.payload.receiver_id === "owner" && checkRole("gym")))
        ) {
          show = true;
        }
        if (show) {
          const highLightMessageData = JSON.parse(
            JSON.stringify(state.chat.highLightMessageData)
          );
          const temp = highLightMessageData.filter(
            (el) => el.message_id === action.payload.message_id
          );
          if (!temp.length) {
            highLightMessageData.push(action.payload);
            state.chat.highLightMessageData = highLightMessageData;
          }
        }
      }
      state.chat.messageList = {
        ...state.chat.messageList,
        [action.payload.message_id]: action.payload,
      };
    },
    setHighLightMessageData: (state, action) => {
      const highLightMessageData = JSON.parse(
        JSON.stringify(state.chat.highLightMessageData)
      );
      highLightMessageData.push(action.payload);
      state.chat.highLightMessageData = highLightMessageData;
    },
    deleteHighLightMessageData: (state) => {
      const highLightmessageData = JSON.parse(
        JSON.stringify(state.chat.highLightMessageData)
      );
      state.chat.highLightMessageData = highLightmessageData.splice(
        1,
        highLightmessageData.length - 1
      );
    },
    setCurrentPage: (state, action) => {
      state.pagination.currentPage = action.payload;
    },
    togglePagination: (state, action) => {
      state.pagination.paginationStatus = action.payload;
    },
    setPageSize: (state, action) => {
      state.pagination.boardPageSize = action.payload.boardPageSize;
      state.pagination.videoPageSize = action.payload.videoPageSize;
      state.pagination.hangoutPageSize = action.payload.hangoutPageSize;
      state.pagination.paginationStatus = false;
      if (
        state.data.low_latency_mode ||
        state.data.activity_status !== staticVar.roomStarted
      ) {
        state.data.canvasUpdate = true;
      }
    },
  },
});

export const getCurrentClassData = (state) => state.currentClass.data;
export const getCurrentClassChat = (state) => state.currentClass.chat;
export const getCurrentClassStorageData = (state) => state.currentClass.storage;
export const getCurrentClassUserData = (state, user_id) =>
  state.currentClass.data.allUsers[user_id];
export const getCurrentClassObj = (state) => state.currentClass;
export const getCurrentClassPagination = (state) =>
  state.currentClass.pagination;
export const getCurrentClassAvailableUser = (state) =>
  getUserArray(
    [...Object.values(state.currentClass.data.allUsers)],
    state.currentClass.data.activity_status
  );
export const {
  resetCurrentClass,
  setClassData,
  addActivityId,
  streamStart,
  streamEnd,
  setClassAverage,
  addUser,
  removeUser,
  staffJoined,
  staffLeft,
  setToken,
  setSession,
  userAddZoom,
  userRemoveZoom,
  setCoachData,
  setCoachRemove,
  addUserId,
  deleteUserId,
  setStream,
  setTotalSeconds,
  coachDataAdd,
  zoomCoachVideoUpdate,
  updateData,
  videoStateChange,
  setCount,
  resetCount,
  hostUpdate,
  mainHostUpdate,
  setClassStorage,
  avSetupToggle,
  updateUserHeartRate,
  stopAttendeeVideos,
  startAttendeeVideos,
  toggleCanvasStatus,
  setVideoStatus,
  setActiveSpeaker,
  updateClassData,
  deviceUpdated,
  setMessageList,
  addNewMessage,
  setHighLightMessageData,
  deleteHighLightMessageData,
  setPassInfo,
  setCurrentPage,
  setPageSize,
  togglePagination,
  updateMemberStream,
  antMediaStatus,
  setActiveSpeakerStatus,
  setUserMuted,
} = currentClassSlice.actions;
export default currentClassSlice.reducer;
